export default class OptionsDecorator {
  // Avoid issues with numerical vs. string kay by using "==", not "===".
  // eslint-disable-next-line
  static optionForValue = (value, options) => value && options?.find(option => value == option.value)

  static optionsForValues = (values, options) => options?.filter(option => values?.includes(option.value))

  static valueToLabel = (value, options) => this.optionForValue(value, options)?.label

  static valuesToLabel = (values, options) => values?.map((value) => this.valueToLabel(value, options)).join(", ")

  static toOption = (value) => { return { value: value, label: value } }

  static createUnavailableOption = (value) => value && { value: value, label: value, unavailable: true }

  static unavailableOption = (option) => { option['unavailable'] = true; return option }

  static inclusiveOptionForValue = (value, options) =>
    this.optionForValue(value, options) || this.createUnavailableOption(value)

  static inclusiveOptionsForValues = (values, options) => {
    return values ?
      Array.from(values).map((option) => this.inclusiveOptionForValue(option, options))
      :
      []
  }

  static inclusiveOptions = (currentOptions, options) => {
    var newOptions = options?.slice() || []

    currentOptions ||= []
    currentOptions = Array.isArray(currentOptions) ? currentOptions : Array.from(currentOptions)

    currentOptions.forEach(currentOption => {
      newOptions.push(
        this.optionForValue(currentOption.value, options) || this.unavailableOption(currentOption)
      )
    })
    return newOptions
  }

  static appendValuesToOptions = (currentValues, options) => {
    var newOptions = options?.slice() || []

    currentValues ||= []

    currentValues.forEach(currentValue => {
      this.optionForValue(currentValue, options) || newOptions.push(this.createUnavailableOption(currentValue))
    })
    return newOptions
  }

  static appendValueToOptions = (currentValue, options) => {
    var newOptions = options?.slice() || []

    if (currentValue && !this.optionForValue(currentValue, options)) {
      newOptions.push(this.createUnavailableOption(currentValue))
    }
    return newOptions
  }

}
